"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TranslateFillText = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TranslateFillText_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.978 5A5.5 5.5 0 1 0 5 10.978V8c0-.15.011-.298.032-.442-.669.459-1.44.818-2.318 1.093a5.094 5.094 0 0 0-.532-.819c1.043-.274 1.916-.67 2.63-1.215-.635-.722-1.117-1.6-1.494-2.628h-1.01v-.826h2.75V2.057h.869v1.106H8.72v.826H7.693c-.145.4-.31.772-.494 1.12C7.454 5.037 7.722 5 8 5h2.978ZM10.08 11.864h1.753l-.88-2.488-.872 2.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.026 7.678A2.014 2.014 0 0 0 6 8v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8a1.997 1.997 0 0 0-1.974 1.678Zm4.43.522h1.073l2.176 5.8h-1.112l-.456-1.288H9.785L9.337 14h-1.04l2.16-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.708 3.989H4.25a6.152 6.152 0 0 0 1.252 2.002c.51-.55.91-1.212 1.206-2.002Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TranslateFillText_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TranslateFillText;
exports["default"] = _default;